export default __webpack_public_path__ + "static/media/chart-blue.78d0f418.svg";